var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"form-code",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.getCode()}}},[_vm._v(_vm._s(_vm.codeName))])
}
var staticRenderFns = []

export { render, staticRenderFns }